<script lang="ts" setup>
import { ref, onMounted, reactive } from "vue";
import { mountedBase, BaseSetup, onDelete, onSave } from "@/DataLoaderStatic";
import { goBack } from "@/NavigationHelper";
import AUApi from "@/api";

import {
  createEditorValidator,
  provideEditorValidator,
} from "@/components/EditorValidator";
import { showSnackbar } from "@/UIHelper";
const validator = createEditorValidator();
provideEditorValidator(validator);

const emit = defineEmits(["back", "save"]);
const props = defineProps<{
  zeitbereichUebergabe: APIZeitbereich;
  showClose?: boolean;
}>();

let deleteVisible = ref<boolean>(false);
const pageParams: DataPageParameter = {
  zeitbereich: AUApi.Current.zeitbereich,
  insertMode: false,
  query: "WEB_PZE_Bestaetigungen",
  emitBack: () => emit("back"),
};
const uiData = reactive<DataPageUIData>(BaseSetup(pageParams));

onMounted(async () => {
  pageParams.zeitbereich = props.zeitbereichUebergabe;
  await mountedBase(uiData, pageParams);
  if (!uiData.showLoading && uiData.data) {
    if (uiData.data && uiData.data[0].aic_Bew_pool) {
      deleteVisible.value = true;
    }
  }

  uiData.showLoading = false;
  uiData.initialized = true;
});
async function bewDelete() {
  if (uiData.data && uiData.data[0].aic_Bew_pool) {
    await onDelete(uiData, pageParams, uiData.data[0].aic_Bew_pool, "");
    emit("back");
  }
}
async function save() {
  const { valid, invalidFields } = await validator.validateAsync();
  if (!valid) {
    showSnackbar({
      text:
        "Validierung fehlgeschlagen - Bitte prüfen! (" +
        invalidFields.join(", ") +
        ")",
      duration: 4000,
      color: "error",
    });
    return;
  }
  await onSave(uiData, pageParams, 0, "");
  goBack();
}
</script>
<template>
  <v-sheet class="pa-0">
    <v-progress-linear
      :indeterminate="true"
      v-if="uiData.showLoading"
      color="dvhSlider"
    ></v-progress-linear>
    <v-expansion-panels class="pa-0" rounded="0">
      <v-expansion-panel v-if="uiData.initialized">
        <v-expansion-panel-title
          disable-icon-rotate
          class="subtitle-1 dvhBackground lighten-2 white--text"
        >
          <span style="color: white">{{ uiData.header.bezeichnung }}</span>

          <template v-slot:actions>
            <v-icon color="white">$expand</v-icon>
          </template>
        </v-expansion-panel-title>
        <v-expansion-panel-text cols="12" sm="6" lg="6" md="6">
          <EditComboBox :isRequired="true" kennung="PV_BESTAETIGUNG" />

          <EditFileChoicer :isRequired="true" kennung="DOKUMENT_DATENBANK" />

          <EditTextArea :clearable="false" kennung="MEMO_MEMO" />
          <div>
            <v-spacer></v-spacer>
            <CommonBaseButtons
              v-if="uiData.initialized"
              :backVisible="false"
              :deleteVisible="deleteVisible"
              :createVisible="false"
              :refreshVisible="false"
              :saveVisible="true"
              @delete="bewDelete"
              @save="save"
            ></CommonBaseButtons>
          </div>
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-sheet>
</template>
<style scoped>
.dvhCol {
  padding-right: 0px;
  padding-left: 10px;
  padding-top: 15px;
  padding-bottom: 0px;
}
</style>
